import { Link } from "react-router-dom";
import { useState } from "react";

const footerLinks = {
  navigation: [
    { label: "首页", path: "/" },
    { label: "今日大瓜", path: "/content" },
    { label: "网红翻车", path: "/content/wanghong" },
    { label: "反差视频", path: "/content/fancha" },
    { label: "酒店猛料", path: "/content/jiudian" },
  ],
  social: [
    { label: "微博吃瓜", path: "#" },
    { label: "微信公众号", path: "#" },
    { label: "抖音爆料", path: "#" },
    { label: "小红书追踪", path: "#" },
  ],
};

export default function Footer() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [statusMsg, setStatusMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const form = e.currentTarget as HTMLFormElement;
    const honeypot = form.querySelector<HTMLInputElement>(".hn-field");
    if (honeypot && honeypot.value.trim() !== "") {
      setStatus("success");
      setStatusMsg("订阅成功！感谢加入深夜基地。");
      setEmail("");
      return;
    }

    if (!email.trim()) {
      setStatus("error");
      setStatusMsg("请输入有效邮箱地址");
      return;
    }

    setStatus("loading");
    try {
      const formData = new URLSearchParams();
      formData.append("email", email);
      formData.append("source", "footer_newsletter");

      await fetch("https://readdy.ai/api/form/d90hoh84jh3v1cgksmbg", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });

      setStatus("success");
      setStatusMsg("订阅成功！感谢加入深夜基地。");
      setEmail("");
    } catch {
      setStatus("error");
      setStatusMsg("网络异常，请稍后重试");
    }
  };

  return (
    <footer className="bg-background-900 text-foreground-100">
      {/* Main footer */}
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          {/* Column 1 - Brand */}
          <div className="flex flex-col gap-4">
            <Link to="/" className="text-xl font-heading font-bold text-background-50 whitespace-nowrap">
              51每日大赛
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed">
              24小时不打烊爆料站<br />
              资深吃瓜群众的深夜专属基地<br />
              带你看遍全网大瓜
            </p>
          </div>

          {/* Column 2 - Newsletter */}
          <div className="flex flex-col gap-4">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400">
              订阅深夜基地
            </h4>
            <form
              onSubmit={handleSubmit}
              data-readdy-form
              className="flex flex-col gap-3"
            >
              {/* Honeypot */}
              <input
                type="text"
                name="phone_alt"
                className="hn-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />
              <div className="flex border-b border-foreground-500/40 focus-within:border-accent-400 transition-colors">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setStatus("idle");
                  }}
                  placeholder="输入邮箱订阅最新爆料"
                  className="flex-1 bg-transparent py-2.5 text-sm text-background-50 placeholder-foreground-500 outline-none"
                  required
                />
                <button
                  type="submit"
                  disabled={status === "loading"}
                  className="px-3 flex items-center justify-center text-foreground-300 hover:text-accent-400 transition-colors cursor-pointer disabled:opacity-50"
                >
                  <i className={`text-lg ${status === "loading" ? "ri-loader-4-line animate-spin" : "ri-arrow-right-line"}`}></i>
                </button>
              </div>
              {status !== "idle" && (
                <p className={`text-xs ${status === "success" ? "text-accent-400" : "text-primary-400"}`}>
                  {statusMsg}
                </p>
              )}
              <p className="text-xs text-foreground-500">
                订阅即表示同意接收爆料推送，
                <a href="#" className="underline hover:text-foreground-300 transition-colors">隐私政策</a>
              </p>
            </form>
          </div>

          {/* Column 3 - Navigation */}
          <div className="flex flex-col gap-4">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400">
              快速导航
            </h4>
            <div className="flex flex-col gap-2.5">
              {footerLinks.navigation.map((link) => (
                <Link
                  key={link.label}
                  to={link.path}
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Column 4 - Social */}
          <div className="flex flex-col gap-4">
            <h4 className="text-xs font-semibold uppercase tracking-wider text-foreground-400">
              关注我们
            </h4>
            <div className="flex flex-col gap-2.5">
              {footerLinks.social.map((link) => (
                <a
                  key={link.label}
                  href={link.path}
                  className="text-sm text-foreground-300 hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap"
                  rel="nofollow noopener noreferrer"
                  target="_blank"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom decorative lettering */}
      <div className="overflow-hidden border-t border-background-800/50">
        <div className="py-6 md:py-10 text-center">
          <span className="text-5xl md:text-7xl lg:text-8xl font-heading font-bold text-background-800 tracking-tight select-none opacity-60 whitespace-nowrap">
            51DAILYNEWS
          </span>
        </div>
      </div>

      {/* Copyright bar */}
      <div className="border-t border-background-800/50">
        <div className="w-full px-4 md:px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 51每日大赛. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors">服务条款</a>
          </div>
        </div>
      </div>
    </footer>
  );
}